import { NavLink } from "react-router-dom";



const Header = () => {
  return (
    <header className="header">
      <nav className="navbar navbar-expand-lg navbar-light bg-light sticky-top">
        <button className="navbar-toggler btn-bars" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse justify-content-center" id="navbarNav">
          <ul className="navbar-nav global__navlist">
            <li className="nav-item">
              <NavLink className="nav-link" exact activeClassName="activeLink" to="/">Inicio</NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" activeClassName="activeLink" to="/premios">Premios</NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" activeClassName="activeLink" to="/galeria">Galería</NavLink>
            </li>
            <li className="nav-item">
            <NavLink className="nav-link" activeClassName="activeLink" to="/anteriores">Años anteriores</NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" activeClassName="activeLink" to="/bases">Bases y Mecánica</NavLink>
            </li>
          </ul>
        </div>
      </nav>
    </header>
  );
};

export default Header;
